import React from 'react';
import './error.scss';

interface Props {
}

const Error: React.FC<Props> = () => {

	return (
		<div className="sa-error">
			<div className="sa-error-main">
				<h1>Oops!</h1>
				<p>Unfortunately, there has been an error.</p>
				<p>Please reload the app. If the problem persists
					contact the SmartAgent team.</p>
			</div>
		</div>
	);

};

export default Error;
